import { SlotCourseRef } from "../../../../services/school-dosification/school-dosification.types";

/**
 * SCRUM-1076: a week write replaces the whole list of the week, so every edit
 * starts from the courses the backend returned (`assigned_courses`) and sends
 * them back with one change applied. These helpers only build that list; the
 * backend still validates it and the tab reloads whatever it decided.
 */

// Strips a slot course down to what the write endpoint expects.
const toRef = ({
  course_id,
  source_program_id,
}: SlotCourseRef): SlotCourseRef => ({ course_id, source_program_id });

/** The week as the write endpoint expects it, keeping the given order (also
 * the reordered array SortableList hands back after a drop). */
export const toSlotCourseRefs = (
  courses: readonly SlotCourseRef[]
): SlotCourseRef[] => courses.map(toRef);

export const appendCourse = (
  courses: readonly SlotCourseRef[],
  course: SlotCourseRef
): SlotCourseRef[] => [...courses, course].map(toRef);

export const replaceCourseAt = (
  courses: readonly SlotCourseRef[],
  index: number,
  course: SlotCourseRef
): SlotCourseRef[] =>
  courses.map((current, position) =>
    toRef(position === index ? course : current)
  );

/** Removing the only course sends `[]`, which leaves the week «Sin curso». */
export const removeCourseAt = (
  courses: readonly SlotCourseRef[],
  index: number
): SlotCourseRef[] =>
  courses.filter((_, position) => position !== index).map(toRef);

/**
 * Courses the catalogue must block because the week already holds them. The
 * one being replaced stays selectable: picking it again changes nothing.
 * `replacingIndex` is `null` when appending.
 */
export const courseIdsBlockedInWeek = (
  courses: readonly SlotCourseRef[],
  replacingIndex: number | null
): number[] =>
  courses
    .filter((_, position) => position !== replacingIndex)
    .map((course) => course.course_id);
